export const getFileType = (fileName) => {
    if (!fileName) return null;
    const extension = fileName?.split(".").pop()?.toLowerCase();
    switch (extension) {
        case "pdf":
            return "PDF";
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
        case "webp":
            return "IMAGE";
        case "doc":
        case "docx":
            return "DOC";
        case "xls":
        case "xlsx":
            return "XLS";
        default:
            return "OTHER";
    };
};